import apiConfig from './api'

export default {
  getTable: (tableName: string) => `${apiConfig.apiEndpoint}/api/${apiConfig.space}/database/${tableName}/row`
}
